import { Menu } from 'antd';
import styled from 'styled-components';
import { BellOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

export const NotificationMenuWrapper = styled.div`
  position: absolute;
  max-height: 218px;
  width: 350px;
  margin: 6px -64px;
  height: auto;
  max-width: 350px;
  box-shadow: 0px 4px 15px 0px #00000026;
`;

export const StyledBellIcon = styled(BellOutlined)`
  color: #00dcdd;
  font-size: 20px;
  vertical-align: middle;
  margin-right: 4px;
  position: static;
  cursor: pointer;
`;

export const StyledMenu = styled(Menu)`
  border-radius: 10px;
  max-height: 218px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #f0f0f0;
    border: 1px solid white;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 2px;
  }
`;

export const StyledMenuItem = styled(Menu.Item)`
  &:hover {
    background-color: #f0f0f0;
  }
  & > p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f7f7f8;
    padding: 16px 6px;
    margin: 0;
    &:last-child {
      border-bottom: none;
    }
  }
  & > p > span {
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
  }
  .bullet-text,
  .bullet-time,
  .notification-text {
    flex-grow: 1;
    font-size: 12px;
    line-height: 16px;
    color: #748aa1;
  }
  .bullet-text {
    margin-right: 6px;
    font-weight: 400;
  }
  .bullet-time,
  .notification-text {
    margin-right: 6px;
  }
`;

export const StyledCustomLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
